import React from 'react'

export default ({ type = 'div', children, props = {} }) => {
	return React.createElement(
		type,
		{
			dangerouslySetInnerHTML: {
				__html: children
			},
			...props,
		}
	)
}
